import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { StyledButton } from '../styles/StyledButtons';
import type { DeleteConfirmState, GenerateConfirmState } from './fundUpdatesAdmin.types';

interface FundUpdatesAdminDialogsProps {
  deleteConfirm: DeleteConfirmState | null;
  deleteInProgress: boolean;
  generateConfirm: GenerateConfirmState | null;
  onCloseDeleteConfirm: () => void;
  onConfirmDelete: () => void;
  onCloseGenerateConfirm: () => void;
  onConfirmSaveAndGenerate: () => void;
}

export default function FundUpdatesAdminDialogs({
  deleteConfirm,
  deleteInProgress,
  generateConfirm,
  onCloseDeleteConfirm,
  onConfirmDelete,
  onCloseGenerateConfirm,
  onConfirmSaveAndGenerate,
}: FundUpdatesAdminDialogsProps) {
  return (
    <>
      <Dialog
        open={!!deleteConfirm}
        onClose={() => !deleteInProgress && onCloseDeleteConfirm()}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Delete published update?</DialogTitle>
        <DialogContent>
          <DialogContentText>{deleteConfirm?.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseDeleteConfirm} disabled={deleteInProgress}>
            Cancel
          </Button>
          <StyledButton
            noTopSpacing
            buttonVariant="warning"
            onClick={onConfirmDelete}
            disabled={deleteInProgress}
          >
            {deleteInProgress ? <CircularProgress size={18} /> : 'Delete'}
          </StyledButton>
        </DialogActions>
      </Dialog>

      <Dialog open={!!generateConfirm} onClose={onCloseGenerateConfirm} maxWidth="sm" fullWidth>
        <DialogTitle>Save before generating?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The update has unsaved content changes. The AI generates from the saved draft — save now
            so the generated card reflects your latest content.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseGenerateConfirm}>Cancel</Button>
          <Button onClick={onConfirmSaveAndGenerate} variant="contained">
            Save and Generate
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
